const Tasks = [
  {
    name: "My Day List",
    id: 0,
    detail: [
    ],
    display: "yes",
  },
  {
    name: "Important List",
    id: 1,
    detail: [
    ],
  },
  {
    name: "Long Plan",
    id: 2,
    detail: [],
  },
  {
    name: "Tasks",
    id: 3,
    detail: [
    ],
  },
];

export default Tasks;
